import styled from "styled-components";
import InnoIcons from "@InnoIcons/";
import theme from "@theme";

const Container = styled.div`
  margin: 0 auto;
  padding: 10px 24px 24px 24px;
`;

const Header = styled.div`
  margin-bottom: 32px;
`;

const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  margin-bottom: 10px;
`;

const HeaderLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const ActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;

  & > button {
    flex: 0 0 auto;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px 12px 40px;
  font-size: 14px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  outline: none;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;

  &:focus {
    border-color: #0066cc;
    box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);
  }
`;

const ResultsCount = styled.div`
  font-size: 13px;
  color: #666;
  background: #f0f0f0;
  padding: 4px 8px;
  border-radius: 12px;
  white-space: nowrap;
  margin-left: auto;

  @media (max-width: 600px) {
    margin-left: 0;
  }
`;

const Title = styled.p`
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  word-wrap: break-word;
  margin: 0;
  padding: 0;
`;

const Metadata = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 24px;
  color: #666;
  font-size: 14px;
  align-items: center;

  @media (max-width: 600px) {
    column-gap: 16px;
    font-size: 13px;
  }
`;

const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  white-space: nowrap;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
`;

const MediaCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  position: relative;
  border: ${({ selected }) =>
    selected ? "2px solid #1976d2" : "1px solid #eee"};

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
`;

const CheckboxWrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;

  input[type="checkbox"] {
    width: 17px;
    height: 17px;
    cursor: pointer;
    accent-color: #1976d2;
  }
`;

const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: ${({ disabled }) => (disabled ? "#ddd" : "#d32f2f")};
  color: #fff;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

const Thumbnail = styled.div`
  width: 100%;
  height: 100px;
  background: #f5f5f5;
  position: relative;
  overflow: hidden;
`;

const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const MediaType = styled.div`
  position: absolute;
  top: 4px;
  right: 8px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 6px 6px;
  border-radius: 6px;
  font-size: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

// const CardInfo = styled.div`
//   padding: 12px;
//   display: flex;
//   flex-direction: column;
//   gap: 2px;
// `;

const CardInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
  // padding: 12px;
`;

const FileName = styled.span.attrs((props) => ({
  title: props.fulltext,
}))`
  font-size: 12px;
  font-weight: 500;
  color: #1a1a1a;
`;
const FileSize = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #1a1a1a;
  padding: 0px 12px 5px 12px;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ModalHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 16px;
`;

const ModalActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  color: #666;

  &:hover {
    background: #f5f5f5;
    color: #1a1a1a;
  }
`;

const DownloadButton = styled.button`
  background: #0066cc;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;

  &:hover {
    background: #0052a3;
  }
`;

const MediaPreview = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: auto;
  background: #f9f9f9;
`;

const PreviewImage = styled.img`
  max-width: 800px;
  max-height: 600px;
  object-fit: contain;
  border-radius: 8px;
`;

const PreviewVideo = styled.video`
  max-width: 800px;
  max-height: 600px;
  border-radius: 8px;
`;

const Navigation = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavButton = styled.button`
  background: #f5f5f5;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #e5e5e5;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Counter = styled.span`
  font-size: 14px;
  color: #666;
`;

const EmptyState = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 20px;
  color: #999;
`;

const EmptyIcon = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
`;

const EmptyText = styled.p`
  font-size: 16px;
  margin: 0;
`;

const BodyHeader = styled.div`
  padding: 16px 24px;
  background: ${theme.gradient.modernGlass};
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  position: fixed;
  width: 100%;
  z-index: 1000;
  box-shadow: ${theme.modernTokens.shadows.sm};
`;

const BodyContainer = styled.div`
  margin-top: 60px;
`;

const FilterContainer = styled.div`
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  padding: 16px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 350px;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #888;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid ${theme.colors.themeColor};
  border-radius: 5px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
`;

const FileNameEditor = styled.div`
  width: 100%;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  padding: 5px 5px;

  textarea,
  input {
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: anywhere !important;
  }
`;

const SC = {
  Container,
  Header,
  HeaderTop,
  HeaderLeft,
  ActionsRow,
  SearchContainer,
  SearchInput,
  SearchIcon,
  ResultsCount,
  Title,
  Metadata,
  MetaItem,
  Grid,
  MediaCard,
  Thumbnail,
  ThumbnailImage,
  MediaType,
  CardInfo,
  FileName,
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalActions,
  IconButton,
  DownloadButton,
  MediaPreview,
  PreviewImage,
  PreviewVideo,
  Navigation,
  NavButton,
  Counter,
  EmptyState,
  EmptyIcon,
  EmptyText,
  BodyHeader,
  BodyContainer,
  FilterContainer,
  InputContiner,
  InputStyle,
  FileSize,
  CheckboxWrapper,
  DeleteButton,
  FileNameEditor,
};

export default SC;
